import { useEffect, useState } from 'react'
import { checkPlacement } from '../../shared/placement-check'
import type { PlacementVerdict } from '../../shared/placement-check'
import { measureBounds } from './measureBounds'

export interface UsePlacementOpts {
  candidateUrl?: string
  referenceUrl?: string
  measure?: typeof measureBounds
}

/** Undefined until both images are measured, and stays undefined where measuring is impossible. */
export default function usePlacementVerdict({
  candidateUrl,
  referenceUrl,
  measure = measureBounds,
}: UsePlacementOpts): PlacementVerdict | undefined {
  const [verdict, setVerdict] = useState<PlacementVerdict | undefined>(undefined)

  useEffect(() => {
    let live = true
    if (!candidateUrl) {
      setVerdict(undefined)

      return () => {
        live = false
      }
    }

    Promise.all([
      measure(candidateUrl),
      referenceUrl ? measure(referenceUrl) : Promise.resolve(undefined),
    ])
      .then(([candidate, reference]) => {
        if (live) {
          setVerdict(candidate ? checkPlacement(candidate, reference) : undefined)
        }
      })
      .catch(() => {
        if (live) {
          setVerdict(undefined)
        }
      })

    return () => {
      live = false
    }
  }, [candidateUrl, referenceUrl, measure])

  return verdict
}
